import ComingSoon from "@/components/ComingSoon";
import UnderConstructionSvg from "@/components/UnderConstructionSvg";

export default function ScriptsPage() {
  return <ComingSoon featureName="Under Construction" description="Create and deploy custom scripts and configurations. This feature requires backend Scripts/Configurations APIs." illustration={<UnderConstructionSvg />} />;
}
